<template>
    <v-text-field
      v-if="!multiline"
      :label="label"
      :value="value"
      :rules="rules"
      :type="password ? showpwd ? type : 'password' : type"
      :min="min"
      hide-details
      :class="{ changed: is_changed }"
      v-bind="$attrs"
      v-on="$listeners"
    >
      <template v-slot:append v-if="password">
        <v-btn small icon tabindex="-1" @click="showpwd = !showpwd">
          <v-icon v-if="showpwd">mdi-eye-off</v-icon>
          <v-icon v-else>mdi-eye</v-icon>
        </v-btn>
      </template>
    </v-text-field>
    <v-textarea
      v-else
      :label="label"
      :value="value"
      :rules="rules"
      clearable
      v-bind="$attrs"
      v-on="$listeners"
    ></v-textarea>
</template>

<script>
export default{

  name: 'textfield',

  props: {
    label: String,
    value: [String, Number],
    rules: Array,
    original_value: [String, Number],
    password: Boolean,
    type: {
      type: String,
      default: 'text'
    },
    min:{
      type: Number,
      default: 0
    },
    multiline: Boolean,
    'prepend-inner-icon': String,
  },

  data: ()=>({
    showpwd: false
  }),

  computed:{
    local_changed() {
      return this.original_value !== undefined ? this.value != this.original_value : false
    },

    is_changed() {
      return this.changed || this.local_changed
    }
  }
}
</script>

<style scoped>
.changed {
  position: relative;
}

.changed::after {
  content: " ";
  color: white;
  text-align: center;
  vertical-align: center;
  padding: 0;
  width: 10px;
  height: 10px;
  position: absolute;
  left: -5px;
  top: -5px;
  border-radius: 50%;
  background: var(--v-warning-base);
}
</style>